import { gql, graphQueryBang } from "shared/lib/graphql"
import { engagementsMapper } from "./gql_data_mapper"

const engagementMetrics = `
  metrics {
    metric_date
    service_engagement_daily
    applet_runs_daily
    applet_enables_daily
    applet_ratings_daily
    cta_clicks_daily
    new_users_all_time
  }
`

const EngagementMetricsQuery = gql`
  query(
    $service: String!
    $metric_start_date: DataServiceDate!
    $metric_end_date: DataServiceDate!
    $category_name: String
    $works_with_channel_name: String
  ) {
    service_metrics(
      channel_module_name: $service
      metric_start_date: $metric_start_date
      metric_end_date: $metric_end_date
      category_name: $category_name
      works_with_channel_module_name: $works_with_channel_name
    ) {
      ENGAGEMENT_FRAGMENT
    }
  }
`

const composedEngagementMetricsQuery = (categoryName, worksWithChannelName) => {
  if (categoryName) {
    return EngagementMetricsQuery.replace(
      /ENGAGEMENT_FRAGMENT/,
      `category_metrics { ${engagementMetrics} }`
    )
  } else if (worksWithChannelName) {
    return EngagementMetricsQuery.replace(
      /ENGAGEMENT_FRAGMENT/,
      `works_with_metrics { ${engagementMetrics} }`
    )
  } else {
    return EngagementMetricsQuery.replace(
      /ENGAGEMENT_FRAGMENT/,
      engagementMetrics
    )
  }
}

export default function engagementMetricsFetcher(
  serviceModuleName,
  categoryName,
  worksWithChannelName,
  { dailyMetricStartDate, currentMetricDate, timePeriodInDays }
) {
  return graphQueryBang(
    composedEngagementMetricsQuery(categoryName, worksWithChannelName),
    {
      service: serviceModuleName,
      metric_start_date: dailyMetricStartDate,
      metric_end_date: currentMetricDate,
      category_name: categoryName,
      works_with_channel_name: worksWithChannelName,
    }
  ).then(data => {
    const {
      metrics,
      category_metrics,
      works_with_metrics,
    } = data.service_metrics
    if (categoryName) {
      return engagementsMapper(category_metrics[0].metrics, timePeriodInDays)
    } else if (worksWithChannelName) {
      return engagementsMapper(works_with_metrics[0].metrics, timePeriodInDays)
    } else {
      return engagementsMapper(metrics, timePeriodInDays)
    }
  })
}
